import { render, staticRenderFns } from "./display-btns.vue?vue&type=template&id=8252d5ca&scoped=true&"
import script from "./display-btns.vue?vue&type=script&lang=js&"
export * from "./display-btns.vue?vue&type=script&lang=js&"
import style0 from "./display-btns.vue?vue&type=style&index=0&id=8252d5ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8252d5ca",
  null
  
)

export default component.exports